import React from 'react';
import { Helmet } from 'react-helmet';

const DEFAULT_TITLE = "Memorised – Personalised Baby Memory Books from Pregnancy to First Birthday";

const PageTitle = ({ title }) => (
  <Helmet>
    <title>{title || DEFAULT_TITLE}</title>
  </Helmet>
);

export default PageTitle;
